import "core-js/stable"
import "regenerator-runtime/runtime"
import React from 'react'
import PropTypes from "prop-types"
import styles from "./TextArea.scss"

const propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  setState: PropTypes.func,
  required: PropTypes.bool,
}

const defaultProps = {
  className: "",
  value: "",
  placeholder: "",
  onClick: null,
  onChange: null,
  setState: null,
  required: false,
}

const TextArea = (props) => {
  return (
    <div className={props.className}>
      <label>{props.label}</label>
      <textarea
        className={styles.textarea}
        id={props.id}
        name={props.name}
        value={props.value}
        placeholder={props.placeholder}
        onClick={props.onClick}
        onChange={props.onChange}
        onInput={(e) => props.setState ? props.setState(e.target.value) : null}
        required={props.required}
      />
    </div>
  )
}

TextArea.propTypes = propTypes
TextArea.defaultProps = defaultProps

export default TextArea